import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD,
    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_BY_ID,

    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE,

    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE,

    ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE,

    ITrialGroupItemTemplateCategoryLoadAction,
    ITrialGroupItemTemplateCategoryLoadByIdAction,
    ITrialGroupItemTemplateCategoryLoadFailureAction,
    ITrialGroupItemTemplateCategoryLoadSuccessAction,

    ITrialGroupItemTemplateCategorySaveAction,
    ITrialGroupItemTemplateCategorySaveSuccessAction,
    ITrialGroupItemTemplateCategorySaveFailureAction,

    ITrialGroupItemTemplateCategoryCreateAction,
    ITrialGroupItemTemplateCategoryCreateSuccessAction,
    ITrialGroupItemTemplateCategoryCreateFailureAction,

    ITrialGroupItemTemplateCategoryValidateAction,
    ITrialGroupItemTemplateCategoryValidateSuccessAction,
    ITrialGroupItemTemplateCategoryValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialGroupItemTemplateCategories";
import { trialGroupItemTemplateCategoriesApi } from "../services/trialGroupItemTemplateCategories";


export const
    getTrialGroupItemTemplateCategoriesEpic = (action$): Observable<ITrialGroupItemTemplateCategoryLoadSuccessAction | ITrialGroupItemTemplateCategoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD)
            .mergeMap((_action: ITrialGroupItemTemplateCategoryLoadAction) => {
                return trialGroupItemTemplateCategoriesApi
                    .getTrialGroupItemTemplateCategories()
                    .map(response =>
                        LoadSuccess(response.trialGroupItemTemplateCategories, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialGroupItemTemplateCategoryByIdEpic = (action$): Observable<ITrialGroupItemTemplateCategoryLoadSuccessAction | ITrialGroupItemTemplateCategoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_LOAD_BY_ID)
            .mergeMap((action: ITrialGroupItemTemplateCategoryLoadByIdAction) => {
                return trialGroupItemTemplateCategoriesApi
                    .getTrialGroupItemTemplateCategoryById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialGroupItemTemplateCategory, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialGroupItemTemplateCategoryEpic = (action$): Observable<ITrialGroupItemTemplateCategorySaveSuccessAction | ITrialGroupItemTemplateCategorySaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_SAVE)
            .mergeMap((action: ITrialGroupItemTemplateCategorySaveAction) => {
                return trialGroupItemTemplateCategoriesApi
                    .setTrialGroupItemTemplateCategory(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialGroupItemTemplateCategory, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialGroupItemTemplateCategoryEpic = (action$): Observable<ITrialGroupItemTemplateCategoryCreateSuccessAction | ITrialGroupItemTemplateCategoryCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_CREATE)
            .mergeMap((_action: ITrialGroupItemTemplateCategoryCreateAction) => {
                return trialGroupItemTemplateCategoriesApi
                    .createTrialGroupItemTemplateCategory()
                    .map(response =>
                        CreateSuccess(
                            response.trialGroupItemTemplateCategory,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialGroupItemTemplateCategoryEpic = (action$): Observable<ITrialGroupItemTemplateCategoryValidateSuccessAction | ITrialGroupItemTemplateCategoryValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALGROUPITEMTEMPLATECATEGORIES_VALIDATE)
            .mergeMap((action: ITrialGroupItemTemplateCategoryValidateAction) => {
                return trialGroupItemTemplateCategoriesApi
                    .validateTrialGroupItemTemplateCategory(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialGroupItemTemplateCategory, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



